var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vertical-center"},[_c('div',{staticClass:"container text-center"},[_c('h1',{staticClass:"text-primary text-stilusos"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('p'),_vm._v(" "),_c('transition',{attrs:{"name":"slide-vertical","mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e7e9ea0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/Guest.vue
// module id = null
// module chunks = 